import { render } from "./LeadHotelBooking.vue?vue&type=template&id=ddf8d988"
import script from "./LeadHotelBooking.vue?vue&type=script&lang=js"
export * from "./LeadHotelBooking.vue?vue&type=script&lang=js"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__